/* global Units, Forms, Option */

window.Units || (window.Units = {})

Units.departmentsSelect = () => {
  $(document).off('change.positionUnit').on('change.positionUnit', '#position_unit_id', function () {
    const UnitId = $(this).val() || 0

    $('#s2id_position_department_id .select2-choice').addClass('ui-autocomplete-loading')

    $.ajax({
      url: '/units/' + UnitId + '/departments/active',
      method: 'GET',
      dataType: 'json'
    }).done(data => {
      $('#s2id_position_department_id .select2-choice').removeClass('ui-autocomplete-loading')
      $('#position_department_id').prop('disabled', false)
      Units.populate_departments_select2('.unit-related-departments', data)
    })
  })

  $(document).off('change.userUnits').on('change.userUnits', '#user_related_unit_ids', function () {
    const unitIds = [...this.options].filter(options => options.selected).map(option => option.value) || []
    Units._groupedDepartments(unitIds)
  })

  $(document).off('change.positionDepartments').on('change.positionDepartments', '#position_department_id', function (e) {
    const selectedOption = $(this).find('option:selected')
    const costCenter = selectedOption.data('costCenter')
    if (costCenter) {
      $('#position_cost_center_id').val(costCenter.id).trigger('change')
    }
  })

  $(function () {
    const allowUnits = $('#user_related_department_ids').data('allow-units')
    const unitIds = $('#user_related_department_ids').data('unit-ids')

    if (!allowUnits && unitIds !== undefined) {
      Units._groupedDepartments(unitIds)
    }
  })
}

Units.addressesSelect = () => {
  $(document).off('change.positionUnitAddr').on('change.positionUnitAddr', '#position_unit_id', function (e) {
    const UnitId = $(this).val() || 0
    if (e.target.value !== '') {
      $('.position-locations').slideDown()
    } else {
      $('.position-locations').slideUp()
    }
    Units.updateAddressesByUnit(UnitId)
  })

  $(document).off('change.relatedUnitIds')
    .on('change.relatedUnitIds', '#user_related_unit_ids, #department_unit_ids', function () {
      if (document.querySelectorAll('select.unit-ids-related-addresses').length === 0) return

      const unitIds = $(this).val() || []
      $.ajax({
        url: '/addresses/for_units',
        method: 'GET',
        dataType: 'json',
        data: { unit_ids: unitIds, position_id: $('#position_id').val() }
      }).done(data => { Units.populate_select2('select.unit-ids-related-addresses', data) })
    })

  $('#position_unit_id').trigger('change')
  $('#user_unit_id').trigger('change')
}

Units.updateAddressesByUnit = (unitIds) => {
  if (document.querySelectorAll('select.unit-related-addresses, select.unit-ids-related-addresses').length === 0) return

  $.ajax({
    url: '/addresses/for_units',
    method: 'GET',
    dataType: 'json',
    data: { unit_ids: unitIds, position_id: $('#position_id').val() }
  }).done(data => { Units.populate_select2('select.unit-related-addresses, select.unit-ids-related-addresses', data) })
}

Units.populate_select2 = (selector, data) => {
  document.querySelectorAll(selector).forEach(element => {
    const select = $(element)
    const selected = select.val() || select.data('selected')

    select.select2('destroy')
    select.empty()
    select.select2('val', '')
    select.append(new Option())
    data.forEach(elem => {
      select.append(new Option(elem.name, elem.id))
    })
    Forms.initSelect2(select)

    select.val(selected).trigger('change')
  })
}

Units.populate_departments_select2 = (selector, data) => {
  document.querySelectorAll(selector).forEach(element => {
    const select = $(element)
    const selected = select.val() || select.data('selected')
    select.select2('destroy')
    select.empty()
    select.select2('val', '')
    select.append(new Option())

    data.forEach(elem => {
      const option = new Option(elem.name, elem?.id || elem.department_id)
      option.setAttribute('class', `depth_${elem.depth}`)
      select.append(option)
    })
    Forms.initSelect2(select)
    select.val(selected).trigger('change')
  })
}

Units.populate_departments_select_box = (selector, data) => {
  const selectBox = $(selector)
  const selectedIds = selectBox.val()
  selectBox.empty()

  data.items.forEach(unit => {
    const optGroup = document.createElement('optgroup')
    optGroup.setAttribute('label', unit.name)

    unit.active_departments.forEach(department => {
      const option = new Option(
        department.name,
        department.id,
        false,
        selectedIds.includes(department.id)
      )
      option.setAttribute('class', `depth_${department.depth}`)
      optGroup.appendChild(option)
    })

    selectBox.append(optGroup)
  })

  selectBox.val(selectedIds).trigger('change')
}

Units._groupedDepartments = (unitIds) => {
  const url = new URL(`${document.location.origin}/units/departments/groupped.json`)
  unitIds.forEach(unitId => url.searchParams.append('unit_ids[]', unitId))
  fetch(url, { method: 'GET' })
    .then(response => response.json())
    .then(data => {
      Units.populate_departments_select_box('#user_related_department_ids', data)
    })
}
